// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__AnxmI","topBottomGutter":"Layout_topBottomGutter__3w7ZP"};